<template>
  <AppView
    padd-bottom
  >
    <TopNav
      slot="top-app-view"
      title="Frequently Asked Questions For Mentees"
      title-class="lg:ml-body lg-app:tw-font-bold"
      type="menu"
      @input="openSideNav()"
    />

    <template v-if="loading">
      <p class="tw-text-center tw-my-12 tw-text-xs opacity-54 tw-italic">loading...</p>
    </template>
    <template v-else>
      <component :is="currentCompany" />
    </template>
  </AppView>
</template>

<script>
import KengenFAQMentee from '@/views/_partials/KengenFAQMentee.vue';
import AnyFAQMentee from '@/views/_partials/AnyFAQMentee.vue';
import FellowshipFAQMentee from '@/views/_partials/FellowshipFAQMentee.vue';
import visitorsMixin from '@/mixins/visitors';

export default {
  name: 'FAQMenteeView',
  mixins: [visitorsMixin],
  components: {
    kengen: KengenFAQMentee,
    fellowship: FellowshipFAQMentee,
    any: AnyFAQMentee,
  },
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    this.loading = true;

    // // get scope id
    // await this.$store.dispatch('setScope');
    // await this.$store.dispatch('evaluateScope');
    await this.$nextTick();

    // this.scopeId = this.$store.getters.scopeId;

    await this.$nextTick();

    this.loading = false;
  },
};
</script>

<style>

</style>
